module.exports = {
  invoice_drawCollectInvoice: 'Выставление/получение счёта',
  invoice_queryInvoice: 'Поиск счёта',
  invoice_invoiceCategory: 'Тип счёта',
  invoice_invoiceDownloadLabel: 'Скачать',
  invoice_electronicInvoiceDownload: 'Скачать электронный счёт',
  invoice_sendEmail: 'Отправить',
  invoice_mailSend: 'Отправить на email',
  invoice_sendEmailLog: 'Журнал',
  invoice_downloadTimes: 'Количество скачиваний клиентом',
  invoice_electronicInvoiceSendStatus: 'Статус отправки электронного счёта',
  invoice_download: 'Скачать',
  invoice_salesDepartment: 'Отдел продаж',
  invoice_opDepartment: 'Операционный отдел',
  invoice_chineseDescriptionOfGoods: 'Наименование товара на китайском',
  invoice_englishDescriptionOfGoods: 'Наименование товара на английском',
  billingJob_taxRate: 'Налоговая ставка',
  invoice_hedging: 'Хеджирование',
  invoice_selectTheHedging: 'Пожалуйста, найдите и выберите для хеджирования',
  invoice_return: 'Назад',
  invoice_query: 'Поиск',
  invoice_invoicing: 'Выставить счёт',
  invoice_collectInvoice: 'Получить счёт',
  billingJob_billDate: 'Дата счёта',
  invoice_confirm: 'Подтвердить',
  invoice_hedgingInvoice: 'Хеджирование счёта',
  invoice_hedgingCollectingInvoice: 'Получение счёта с хеджированием',
  invoice_cancelBillConfirmation: 'Отмена подтверждения счёта',
  invoice_revenueAndExpenditureMethod: 'Способ оплаты:',
  invoice_all: 'Все',
  invoice_convert: 'Эквивалент',
  invoice_convert_after_tax: 'Эквивалент цены без налога',
  invoice_receivables: 'Дебиторская задолженность',
  invoice_payables: 'Кредиторская задолженность',
  invoice_feeType: 'Тип расходов:',
  invoice_domestic: 'Внутренние',
  invoice_international: 'Международные',
  invoice_charges: 'Расходы',
  invoice_business: 'Операция',
  invoice_bill: 'Счёт',
  invoice_accountStatement: 'Сверка счёта',
  invoice_defaultInformation: 'Выставить счёт по умолчанию',
  invoice_customer: 'Клиент',
  invoice_businessNumber: 'Номер операции',
  invoice_consignationCompany: 'Заказчик',
  invoice_settlementCompany: 'Расчётная единица',
  invoice_mblNo: 'Основной номер',
  invoice_vessel: 'Название судна',
  invoice_voyage: 'Рейс',
  invoice_billNo: 'Номер счёта',
  invoice_accountStatementNo: 'Номер сверки счёта',
  invoice_paymentApplicationNo: 'Номер заявки на оплату',
  invoice_itemNo: 'Номер проекта',
  invoice_bookingNo: 'Номер бронирования',
  invoice_businessType: 'Тип операции',
  invoice_solicitationType: 'Тип сбора груза',
  invoice_amountRange: 'Диапазон суммы',
  invoice_chargeItem: 'Наименование расхода',
  invoice_customerTypeId: 'Тип клиента',
  invoice_businessDate: 'Дата операции',
  invoice_receivablesInvoicingDate: 'Дата выставления счета к получению',
  invoice_currency: 'Валюта',
  invoice_operation: 'Действие',
  invoice_sales: 'Продажи',
  invoice_cargoSalesId: 'Продажи по сбору груза',
  invoice_advanceMoneyForAnotherOrNot: 'Авансирование',
  invoice_adjustedOrNot: 'Корректировка',
  invoice_wroteOffOrNot: 'Проведено ли списание',
  invoice_generatedBillsOrNot: 'Сформирован ли счет',
  invoice_invoicedOrNot: 'Выставлен ли счет',
  invoice_appliedForPaymentOrNot: 'Подана ли заявка на оплату',
  invoice_receivablesInvoicingStatus: 'Статус счета к получению',
  invoice_payablesInvoicingStatus: 'Статус счета к оплате',
  invoice_department: 'Отдел',
  invoice_customerLevel: 'Уровень клиента',
  invoice_settlementMethod: 'Способ расчета',
  invoice_contactPerson: 'Контактное лицо',
  invoice_businessReferenceNumber: 'Референс операции',
  invoice_invoiceHeader: 'Наименование в счете',
  invoice_inputBy: 'Создатель счета',
  invoice_dateCreated: 'Время создания счета',
  invoice_accrued: 'Начислено',
  invoice_invoicingMethod: 'Способ выставления счета',
  invoice_businessStatus: 'Статус операции',
  invoice_feeStatus: 'Статус расхода',
  invoice_confirmStatus: 'Статус подтверждения',
  invoice_vesselAndVoyage: 'Название судна и рейс',
  invoice_portOfLoading: 'Порт отправления',
  invoice_portOfDestination: 'Порт назначения',
  invoice_financialDate: 'Финансовая дата',
  invoice_domesticOrInternational: 'Внутренний/внешний',
  invoice_paymentType: 'Тип платежа',
  invoice_quantity: 'Количество',
  invoice_taxIncludedPrice: 'Цена с налогом',
  invoice_taxExcludedPrice: 'Цена без налога',
  invoice_taxAmount: 'Сумма налога',
  invoice_theAmountOfWriteOffs: 'Сумма списания',
  invoice_amountNotWrittenOff: 'Несписанная сумма',
  invoice_chargesRemarks: 'Примечание к расходам',
  invoice_totalAmountNotWrittenOff: 'Итого несписанная сумма',
  invoice_receivablesInvoicing: 'Счет к получению',
  invoice_payablesInvoicing: 'Выставление счета к оплате',
  invoice_payablesCollectInvoice: 'Получение счета к оплате',
  invoice_invoicingType: 'Тип выставления счета',
  invoice_makeType: 'Вид счета',
  invoice_invoiceStatus: 'Статус счета',
  invoice_makePaper: 'Бумажный счет',
  invoice_makeElectronic: 'Электронный счет',
  invoice_consolidatedInvoice: 'Консолидированное выставление счета (группировка по расчетным единицам)',
  invoice_consolidatedInvoiceCollect: 'Консолидированное получение счета (группировка по расчетным единицам)',
  invoice_invoicingAccordingToBusiness: 'Выставление счета по операциям (группировка по расчетным единицам)',
  invoice_invoicingAccordingToBusinessCollect: 'Получение счета по операциям (группировка по расчетным единицам)',
  invoice_invoicingAccordingToRecords: 'Выставление счета по записям (каждая запись формирует отдельный счет)',
  invoice_invoicingAccordingToRecordsCollect: 'Получение счета по записям (каждая запись формирует отдельный счет)',
  invoice_invoicingPerRecord: 'Каждая запись формирует отдельный счет',
  invoice_invoiceType: 'Тип счета',
  invoice_CollectInvoiceType: 'Тип получения счета',
  invoice_invoicingAccordingToCurrency: 'Выставление счета по валютам',
  invoice_invoicingAccordingToCurrencyCollect: 'Получение счета по валютам',
  invoice_invoicingPerCurrency: 'Раздельное выставление счета по валютам',
  invoice_invoicingPerCurrencyCollect: 'Раздельное получение счета по валютам',
  invoice_specifyInvoiceCurrency: 'Указание валюты счета',
  invoice_consolidatedCurrency: 'Консолидация валют',
  invoice_invoicingCurrency: 'Валюта выставления счета',
  invoice_invoiceExchangeRate: 'Курс счета',
  invoice_invoicingCurrencyCollect: 'Валюта получения счета',
  invoice_showChargeDetails: 'Отображение детализации расходов в содержании счета',
  invoice_invoicingAccordingToFinancialExchangeRate: 'Выставление счета по финансовому курсу',
  invoice_invoicingAccordingToFinancialExchangeRateCollect: 'Получение счета по финансовому курсу',
  invoice_invoicingAccordingByBillingExchangeRate: 'Выставление счета по курсу счета',
  invoice_invoicingAccordingByBillingExchangeRateCollect: 'Получение счета по курсу счета',
  invoice_generateCostInvoice: 'Формирование счета на затраты',
  invoice_subTotal: 'Промежуточный итог',
  invoice_exchangeRate: 'Курс обмена',
  invoice_alwaysInvoicing: 'Постоянное выставление счета по данному курсу',
  invoice_SplitChargeOnlyChangeQuantity: 'После разделения "цена за единицу" остается неизменной, "количество" обновлено',
  invoice_total: 'Итог',
  invoice_revenueAndExpenditureType: 'Тип оплаты/поступления',
  invoice_invoicingExchangeRate: 'Курс выставления счета',
  invoice_InvoicingAmount: 'Сумма выставления счета',
  invoice_billBusinessNo: 'Номер счета/операции',
  invoice_billBusinessDate: 'Дата счета/операции',
  invoice_accountBillBusinessDate: 'Номер сверки/счета/операции',
  invoice_paymentNotificationAndBusiness: 'Номер платежного уведомления/операции',
  invoice_invoiceInformation: 'Информация о счете',
  invoice_invoiceContent: 'Содержание счета',
  invoice_chargeDetails: 'Детализация расходов',
  invoice_unitPrice: 'Цена за единицу',
  invoice_amount: 'Сумма',
  invoice_invoiceNo: 'Номер счета',
  invoice_invoiceDate: 'Дата выставления счета',
  invoice_invoicingDate: 'Дата счета',
  invoice_bargeETD: 'Дата отправки баржи',
  invoice_billPaymentNo: 'Номер платежного извещения',
  invoice_proofDate: 'Дата документа',
  invoice_writeOffStatus: 'Статус списания',
  invoice_redChargesStatus: 'Статус сторнирования',
  invoice_printOrNot: 'Печатать',
  invoice_invalidOrNot: 'Аннулирован',
  invoice_exportOrNot: 'Экспортировать',
  invoice_invoiceApplicant: 'Заявитель на выставление счета',
  invoice_invoiceVoider: 'Аннулировавший счет',
  invoice_invoiceVoidTime: 'Время аннулирования счета',
  invoice_totalCurrency: 'Итого по валютам',
  invoice_notWrittenOffTotalCurrency: 'Несписанные суммы по валютам',
  invoice_alreadyExportOrNot: 'Экспортирован',
  invoice_havingInvoiceingNoOrNot: 'Наличие номера счета',
  invoice_exportProofFinancialOrNot: 'Экспорт финансового документа',
  invoice_totalAmount: 'Общая сумма',
  invoice_taxFreeAmount: 'Сумма без НДС',
  invoice_customJobType: 'Пользовательский тип операции',
  invoice_userDefinedField1: 'Пользовательское поле 1',
  invoice_userDefinedField2: 'Пользовательское поле 2',
  invoice_userDefinedField3: 'Пользовательское поле 3',
  invoice_userDefinedField4: 'Пользовательское поле 4',
  invoice_containerNo: 'Номер контейнера',
  invoice_voyageLine: 'Маршрут',
  invoice_separateNumber: 'Номер частичной накладной',
  invoice_sp1: 'Копия счета',
  invoice_sp2: 'Плательщик',
  invoice_sp3: 'Номер счета',
  invoice_sp4: 'Очистить',
  invoice_sp5: 'Дата выставления счета',
  invoice_sp6: 'Исходная валюта',
  invoice_sp7: 'Валюта счета',
  invoice_sp8: 'Наш банк',
  invoice_sp9: 'Наш счет',
  invoice_sp10: 'Место отправки',
  invoice_sp11: 'Порт выгрузки',
  invoice_sp12: 'Пункт назначения',
  invoice_sp13: 'Дата отплытия',
  invoice_sp14: 'Дата прибытия',
  invoice_sp15: 'Требования к счету',
  invoice_sp16: 'Название судна и рейс',
  invoice_sp17: 'Развернуть детали',
  invoice_sp18: 'Объединить детали',
  invoice_sp19: 'Груз',
  invoice_sp20: 'Исходная сумма',
  invoice_sp21: 'Пересчитанная сумма',
  invoice_sp22: 'Пересчитанная сумма',
  invoice_sp23: 'Примечание',
  invoice_sp24: 'Финансовые пояснения',
  invoice_sp25: 'Итоговая сумма',
  invoice_sp26: 'Итого',
  invoice_sp27: 'Печать предприятия',
  invoice_sp28: 'Проверка',
  invoice_sp29: 'ИНН (Идентификационный номер налогоплательщика)',
  invoice_theLastPage: 'Предыдущий',
  invoice_theNextPage: 'Следующий',
  invoice_sp30: 'Установить текущие данные как информацию по умолчанию для выставления счетов',
  invoice_sp31: 'Разделение расходов',
  invoice_back: 'Назад',
  invoice_selectInvoiceNo: 'Выбор номера счета',
  invoice_next: 'Далее',
  invoice_invoiceConfirmation: 'Подтвердить выставление счета',
  invoice_collectInvoiceConfirmation: 'Подтвердить получение счета',
  invoice_save: 'Сохранить',
  invoice_print: 'Печать',
  invoice_printAll: 'Печать всех',
  invoice_CATISExport: 'Экспорт в систему "Золотой налог"',
  invoice_CATISPrint: 'Печать через систему "Золотой налог"',
  invoice_CATISInvalid: 'Аннулирование в системе "Золотой налог"',
  invoice_cancel: 'Отмена',
  invoice_close: 'Закрыть',
  invoice_view: 'Просмотр',
  invoice_forceDelete: 'Принудительное удаление',
  invoice_delete: 'Удалить',
  invoice_invalid: 'Аннулировать',
  invoice_exportVATInvoice: 'Экспорт НДС-счета',
  invoice_importVATInvoice: 'Импорт НДС-счета',
  invoice_applyForPayment: 'Запрос на оплату',
  invoice_sp32: 'Экспорт в систему Baiwang',
  invoice_billPaymentState: 'Статус запроса на оплату',
  invoice_downLoad: 'Скачать',
  invoice_BatchDownloadElectronicInvoice: 'Массовое скачивание электронных счетов',
  invoice_UpdateInvoice: 'Редактировать счет',
  invoice_ModifyInvoiceInformation: 'Редактировать информацию о счете',
  invoice_recheck: 'Проверка',
  invoice_cancelRecheck: 'Отменить проверку',
  invoice_approvedStatue: 'Статус проверки',
  invoice_approvedBy: 'Проверяющий',
  invoice_dateApproved: 'Дата проверки',
  invoice_incomePayDate: 'Срок оплаты/поступления',
  invoice_isExtended: 'Просрочено ли',
  invoice_incomeCostDate: 'Срок оплаты/поступления',
  invoice_incomeCostRange: 'Период просрочки',
  invoice_sellTitle: 'Продавец',
  invoice_placeOfDelivery: 'Место получения',
  invoice_differenceAdjustment: 'Корректировка разницы',
  invoice_businessCreateDate: 'Дата создания операции',
  invoice_dateTo: 'по',
  invoice_lockCheckBoxDate: 'Поиск данных старше двух лет',
  invoice_queryLotsOfData: 'Запрос данных старше двух лет',
  invoice_invoiceDateNotEmpty: 'Дата счета-фактуры не может быть пустой!',
  invoice_unlockInvoiceDateQuery: 'Если выбранный диапазон дат счетов превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные старше двух лет?',
  invoice_businessDateNotEmpty: 'Дата операции не может быть пустой!',
  invoice_unlockBusinessDateQuery: 'Если выбранный диапазон дат операций превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные старше двух лет?',
  invoice_actualReceiptDate: 'Фактическая дата получения счета',
  invoice_targetVoucherNo: 'Номер документа контрагента',
  invoice_voucherDate: 'Дата документа 2',
  invoice_redPunch: 'Корректировка (сторно)',
  invoice_etd: 'ETD (Estimated Time of Departure)',
  invoice_eta: 'ETA (Estimated Time of Arrival)',
  invoice_notesOnReceipt: 'Примечание к получению счета',
  invoice_invoiceRemarks: 'Примечание к счету',
  invoice_settleDepartmentPrefix: 'Расчетный отдел',
  invoice_denomination: 'Разделение по валютам',
  lastInvoicingDate: 'Крайний срок выставления счета',
  invoice_ATD: 'ATD (Actual Time of Departure)',
  invoice_OperationTime: 'Дата операции',
  invoice_updateRemark: 'Изменить примечание',
  OurBankAccountNo: 'Наш банковский счет',
  OurBankCurrency: 'Валюта нашего банка',
  RedChargesOrNot: 'Корректировка (сторно)?',
  revenueAndExpenditureType: 'Тип дохода/расхода',
  InvoiceDateCreated: 'Дата создания счета',
  ElInvoiceSendStatus: 'Статус отправки электронного счета',
  ElInvoiceSendPlatformStatus: 'Статус отправки электронного счета в платформу',
  ElInvoiceSendEmailStatus: 'Статус отправки электронного счета на email',
  InvoicingByBusinessDateExchangeRate: 'Выставление счета по курсу на дату операции',
  InvoicingByBusinessDateExchangeRateCollect: 'Получение счета по курсу на дату операции',
  InvoicingByBusinessDateExchangeRateTips: 'Пожалуйста, выберите расходы с одинаковой датой операции для выставления счета!',
  existUnconfirmedStatus: 'В выбранных счетах есть счета со статусом "Не подтверждено". Продолжить выставление счетов?',
  AutoCheckInvoicing: 'Автоматический выбор для выставления счета',
  AutoCheckInvoicingToolTips: 'После использования будут автоматически выбраны суммы, близкие или равные预设金额. Примечание: эта функция не выставляет счета автоматически, для выставления счета требуется ручное действие.',
  DefaultInvoicingAmount: 'Предустановленная сумма счета:',
  AutoCheckInvoicingAmount: 'Автоматический выбор суммы счета',
  AutoCheckInvoicingDialogToolTips: 'Сумма автоматического выбора будет близка или равна预设金额.',
  AutoSplitCharge: 'Автоматическое разделение расходов',
  AutoCalculateSplit: 'Автоматический расчет разделения',
  AutoCalculateSplitResult: 'Результат автоматического разделения',
  IncludingTaxAmountLimit: 'Макс. (с НДС):',
  AutoCheckInvoicingSuccess: 'Операция завершена. Сумма выбранных расходов в RMB: {0} юаней. Для внесения изменений выполните ручной выбор.',
  UseAutoCheckInvoicing: 'Выбор расходов по предустановленной сумме счета',
  AutoAmountCanNotZero: 'Предустановленная сумма счета должна быть больше 0!',
  ArMoreApForAutoCheckInvoicing: 'Операция завершена. Сумма к оплате автоматически выбранных расходов превышает сумму к получению. Прямое выставление счета будет считаться получением. Рекомендуется ручная корректировка.',
  invoice_invoicingAccordingToSettlementAgent: 'Объединенное выставление счетов (по группам расчетных агентов)',
  invoice_invoicingAccordingToSettlementAgentCollect: 'Объединенное получение счетов (по группам расчетных агентов)',
  invoice_invoicingAccordingToTitle: 'Выставление счета по наименованию (каждое наименование формирует отдельный счет)',
  invoice_invoicingAccordingToTitleCollect: 'Получение счета по наименованию (каждое наименование формирует отдельный счет)',
  RequestTaxControlPlatformStatus: 'Успешен ли запрос к налоговой платформе',
  GetInvoiceNumber: 'Получение номера счета',
  NotDoInvoice: 'Счет еще не выставлен в облачном налоговом сервисе. Пожалуйста, сначала выставьте счет.',
  GetInvoiceNoSuccess: 'Идет получение номера счета, пожалуйста, проверьте позже!',
  GetInvoiceNoFail: 'Не удалось получить номер счета-фактуры!',
  NotDoInvoiceBwjsy: 'Еще не выставили счет в Baiwang Jinsui Cloud, сначала создайте счет!',
  GetInvoiceNoSuccessBwjsy: 'Номер счета-фактуры успешно получен!',
  GetInvoiceNoFailPart: 'Не удалось получить некоторые номера счетов-фактур, попробуйте позже!',
  NotInvoice: 'Еще не выставили счет, сначала создайте счет',
  PaperTicketPrinting: 'Печать бумажного счета',
  NameOfSeller: 'Наименование продавца',
  CNYReceived: 'Получено (эквивалент в CNY)',
  CNYNotReceived: 'Не получено (эквивалент в CNY)',
  CNYPaid: 'Оплачено (эквивалент в CNY)',
  CNYNotPaid: 'Не оплачено (эквивалент в CNY)',
  InvoiceNoImport: 'Импорт номеров счетов-фактур',
  SpecificConstraintTypes: 'Специальный тип ограничения',
  PurchaserInformation: 'Информация о покупателе',
  SellerInformation: 'Информация о продавце',
  TypeOfTransport: 'Тип транспортного средства',
  TransportVehicleBrand: 'Номер транспортного средства',
  Origin: 'Место отправления',
  Destination: 'Место назначения',
  NameOfGoodsTransported: 'Наименование перевозимого груза',
  ServiceOfGoodsTransported: 'Услуги по перевозке грузов',
  FeiRedApplicationStatus: 'Статус заявки на электронный красный счет',
  RedFlushReason: 'Причина аннулирования',
  RedApplyFail: 'Заявка на красный счет не прошла, проверьте причину.',
  RedApplying: 'Заявка на красный счет отправлена, дождитесь успешного завершения перед операцией "Экспорт Golden Tax".',
  BatchCheckNotRedStatus: 'Поддерживаются только счета в статусе аннулирования, перепроверьте и завершите операцию.',
  BatchCheckNotRedApplyInvoice: 'Поддерживаются только счета без заявки на красный счет или с неудачной заявкой, перепроверьте и завершите операцию.',
  BatchCheckRedApplySuccessInvoice: 'Поддерживаются только счета с успешной заявкой на красный счет, перепроверьте и завершите операцию.',
  BatchCheckRedFlushInvoice: 'Поддерживается только пакетная обработка счетов с одинаковым статусом, перепроверьте и завершите операцию.',
  BatchCheckRedFlushInvoiceType: 'Поддерживается только пакетная обработка электронных счетов, перепроверьте и завершите операцию.',
  BatchCheckRedFlushInvoiceTipOne: 'Выбранные',
  BatchCheckRedFlushInvoiceTipTwo: 'Счета будут аннулированы',
  IncorrectInvoicing: 'Ошибка в выставлении счета',
  SalesReturn: 'Возврат товара',
  ServiceTermination: 'Прекращение услуг',
  SalesAllowance: 'Скидка при продаже',
  AllElectricInvoicing: 'Электронный счет',
  RealPersonAuth: 'Верификация личности истекла',
  PersonAuth: 'Верификация личности',
  WeChatScanningAgain: 'Откройте налоговое приложение, войдите в личный кабинет, выберите "Личные услуги", авторизуйтесь через сканирование лица, введите логин (номер телефона) и отсканируйте лицо. После успешного входа отсканируйте QR-код для завершения верификации.',
  Certified: 'Верифицировано',
  QdWarningTip: 'Налоговое управление КНР проводит срочные работы по обновлению интерфейса электронных счетов. Программисты работают в авральном режиме. На время обновления используйте официальный сайт для выставления счетов. Приносим извинения за неудобства.',
  FailureDescription: 'Инструкция по запросу к налоговой платформе',
  SelectRightInvoice: 'Выберите соответствующие счета-фактуры!',
  ApplyRed: 'Заявка на красный счет',
  CancelApplyRed: 'Отзыв заявки на красный счет',
  InvoiceNotSyncOrInvalid: 'Счет не синхронизирован или аннулирован, аннулирование невозможно!',
  CloudStarrySkyNotSync: 'Не синхронизировано с Cloud Star, аннулирование невозможно, сначала синхронизируйте!',
  VoidedSuccessfully: 'Успешно аннулировано',
  RateChangedTip: 'Курс на дату счета изменился, обновить курс в счете?',
  RateChangedSuccess: '，Обновление валютного курса успешно！',
  SelectReasonForRedOffsetInvoice: 'Пожалуйста, выберите причину аннулирования счета-фактуры',
  OnlyMaster: 'Только основной счет',
  invoice_chargeCurrencyRate1: 'Курс обмена по валютам 1',
  invoice_chargeCurrencyRate2: 'Курс обмена по валютам 2',
  GetInvoiceNumberVietnam: 'Проверить номер вьетнамского счета-фактуры',
  GetInvoicePdfVietnam: 'Скачать вьетнамский счет-фактуру',
  GetInvoiceStateVietnam: 'Проверить статус вьетнамского счета-фактуры',
  PaymentMethodVietnam: 'Способы оплаты во Вьетнаме',
  InvoiceStateVietnam: 'Статус вьетнамского счета-фактуры',
  PleaseThanOneInvoiceMerge: 'Выберите более одной накладной для объединения',
  Verification: 'Проверка',
  InvoiceDocument: 'документ-счет',
  Missing: 'Отсутствует',
  StartingPleaseWaitForEmail: 'Начинается выполнение объединения счетов. Пожалуйста, дождитесь письма с результатом.',
  NoExistsInTheData: 'В выбранных данных отсутствуют файлы счетов!'
}
